import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { AuthGuard } from './auth.guard';
import { LoginService } from './login.service';
import { NotificationService } from '@nuso/common/util-errors';

@Injectable({
  providedIn: 'root'
})
export class CanUseAdminGuard extends AuthGuard {
  /**
   * Check if the user has admin privileges
   */
  isAdmin(): Observable<boolean> {
    return this.loginService.completedLoginStatus()
      .pipe(
        map(status => {
          if (!status.isLoggedIn || !status.loginSession || !status.loginSession.roles) {
            return false;
          }

          return status.loginSession.roles.includes('admin') ||
                 status.loginSession.roles.includes('superuser');
        })
      );
  }

  override canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    // First check if the user is authenticated using the parent AuthGuard
    return super.canActivate(route, state).pipe(
      switchMap(isAuthenticated => {
        // If not authenticated, parent AuthGuard already handled the redirect
        if (!isAuthenticated) {
          return of(false);
        }

        // If authenticated, check admin permissions
        return this.isAdmin().pipe(
          tap(isAdmin => {
            if (!isAdmin) {
              console.log('logged in but not admin');
              this.router.navigate(['/']);
            }
          })
        );
      })
    );
  }
}